import { render, staticRenderFns } from "./AppMenuListSections.vue?vue&type=template&id=9d974288&scoped=true&"
import script from "./AppMenuListSections.vue?vue&type=script&lang=js&"
export * from "./AppMenuListSections.vue?vue&type=script&lang=js&"
import style0 from "./AppMenuListSections.vue?vue&type=style&index=0&id=9d974288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d974288",
  null
  
)

export default component.exports